import React from 'react'
import { A } from '../../atoms/A'
import { Table, TableCell, TableHeading } from '../../atoms/Table'
import { EmptyCard } from '../../common/EmptyCard'
import { SearchResult } from '../../../types'

type Props = {
  investors: SearchResult['investors']['data']
}

export const InvestorsTable: React.FC<Props> = (props) => {
  if (props.investors.length === 0) {
    return <EmptyCard />
  }

  return (
    <Table>
      <thead>
        <tr>
          <TableHeading>投資会社名</TableHeading>
          <TableHeading>種別</TableHeading>
          <TableHeading>属性</TableHeading>
          <TableHeading>旧または別名</TableHeading>
        </tr>
      </thead>
      <tbody>
        {props.investors.map((investor, i) => (
          <tr data-test-id="domestic-investor-item" key={i}>
            <TableCell>
              <A href={investor.path} decoration="none">
                {investor.name}
              </A>
            </TableCell>
            <TableCell>{investor.category}</TableCell>
            <TableCell>{investor.subCategory}</TableCell>
            <TableCell>{investor.formerName}</TableCell>
          </tr>
        ))}
      </tbody>
    </Table>
  )
}
